import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import UnauthorizedMessage from '../UnauthorizedMessage';
import DynamicTableComponent from '../DynamicTable/DynamicTableComponent';
import '../../app/common/MediaQuery/responsive-tables.css';
import _ from 'lodash';

function WorkLevelMasterTable() {
  const { WorkLevelStore, commonStore } = useStore();
  const { viewItemGroups, viewItemGroupSearchDetails } = WorkLevelStore;
  const { dashboardStore } = useStore();

  useEffect(() => {
    viewItemGroupSearchDetails('', 1);
    // eslint-disable-next-line
  }, []);

  const paginationHandler = (number: any) => {
    viewItemGroups.pageNumber = number;
    let searchValues = dashboardStore.dashboard.searchfilterparams;
    if (
      !_.isEmpty(searchValues) &&
      Object.values(searchValues).every((o) => o !== '') &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      WorkLevelStore.viewItemGroupSearchDetails(searchValues, number);
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      WorkLevelStore.viewItemGroupSortDetails(
        dashboardStore.dashboard.orderData,
        number,
      );
    } else {
      WorkLevelStore.viewItemGroupSearchDetails('', number);
    }
  };

  // if (viewItemGroups.isloading) return <LoadingComponent />;

  return (
    <>
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('AVIB01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('AVIB01') && (
        <div className="large-table-screen">
          <div className="small-table-screen">
            <Segment>
              <Header
                icon="list"
                size="huge"
                dividing
                as="h1"
                content="View Item Group"
                sub
                color="grey"
              />
              <DynamicTableComponent
                data={viewItemGroups.data}
                name={'WorkLevelTable'}
                actiontype={'editdel'}
                pageFunc={paginationHandler}
                pageNumData={viewItemGroups.pageNumber}
                searchFuncData={''}
                loading={viewItemGroups.isloading}
              />
            </Segment>
          </div>
        </div>
      )}
    </>
  );
}

export default observer(WorkLevelMasterTable);
